import { UtilsAccount } from 'utils/account';
import { AFTER_SIGN_IN_ACTION_TYPES, AfterSignIn } from 'services/afterSignIn';
import { saveCurrentLocation } from 'components/QueryRoute';

export const reconstructAndRedirectToGameView = (
  callbackAfterSignin?: () => void,
  routeToSaveInStorage?: string,
  saveRouteKey?: 'casinoSingleGame' | 'login'
) => {
  UtilsAccount.openLoginView({
    routeToSaveInStorage
  });

  if (saveRouteKey) {
    saveCurrentLocation(saveRouteKey, routeToSaveInStorage);
  } else {
    saveCurrentLocation();
  }

  const afterSignIn = new AfterSignIn();
  afterSignIn.appendAction(
    AFTER_SIGN_IN_ACTION_TYPES.RECONSTRUCT_CASINO_VIEW_URL,
    () => {
      return new Promise(resolve => {
        callbackAfterSignin?.();
        resolve(true);
      });
    }
  );
};
